module.exports = __webpack_public_path__ + "static/media/4-item-d.0d054583.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/4-item-d.jpg
// module id = 1170
// module chunks = 33